
import { defineComponent, PropType } from 'vue';
import { CancelUsageStats } from '../cancelFlow';

export default defineComponent({
    name: 'CancelIntercept',
    props: {
        stats: { type: Object as PropType<CancelUsageStats | null>, default: null },
        statsAvailable: { type: Boolean, default: false },
    },
    emits: ['next', 'stay'],
});
